export default {
    parts: [
        'noOrderTitleContainer',
        'noOrderYetHeading',
        'noOrdersContentContainer',
        'noOrdersDescription',
        'noOrdersActionMobile',
        'noOrdersActionButton',
        'noOrdersActionButtonDesktop',
        'maintenanceTitleContainer',
        'maintenanceIndicatorIcon',
        'maintenanceTitle',
        'maintenanceCtaButton',
        'maintenanceContentWrapper',
        'ordersMaintenanceWrapper',
        'ordersMaintenancePageTitle',
        'orderInfoContainer',
        'progressBarContainer',
        'orderPlacedDate',
        'orderTotalWithItemCount',
        'remainingCountBox',
        'ordersCardContainer',
        'orderStatusText',
        'manageOrderButton',
        'showMoreSection',
        'progressBar',
        'showOrdersText',
        'showOrdersTextBold',
        'showMoreButton',
        'OrderHistoryHeading',
        'storeText',
        'onlineText'
    ],
    baseStyle: (props) => ({
        noOrderTitleContainer: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            gap: '6px'
        },
        noOrderYetHeading: {
            fontSize: {base: '12px', lg: '14px'},
            lineHeight: {base: '18px', lg: '20px'},
            fontWeight: '500',
        },
        noOrdersContentContainer: {
            display: 'flex',
            flexDirection: 'column'
        },
        noOrdersDescription: {
            fontSize: {base: '12px', lg: '14px'},
            lineHeight: {base: '18px', lg: '20px'},
            fontWeight: '400',
        },
        noOrdersActionMobile: {
            display: {
                base: 'inline',
                sm: 'none'
            },
            marginLeft: '5px'
        },
        noOrdersActionButton: {
            position: 'relative',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            width: 'fit-content',
            height: 'auto',
            textTransform: 'initial',
            backgroundColor: 'transparent',
            padding: '0',
            margin: '0',
            color: 'black',
            textDecoration: 'underline',
            marginBottom: '5px',

            _hover: {
                backgroundColor: 'transparent'
            }
        },
        noOrdersActionButtonDesktop: {
            display: {
                base: 'none',
                sm: 'block'
            }
        },
        maintenanceContentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            padding: {
                base: 0,
                lg: 0
            }
        },
        maintenanceTitleContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        },
        maintenanceIndicatorIcon: {
            width: '20px',
            height: '20px'
        },
        maintenanceTitle: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '500',
            textTransform: 'capitalize',
            lineHeight: {base: '18px', lg: '20px'},
            textAlign: 'left',
        },
        ordersMaintenanceWrapper: {
            width: {base: '100%', lg: '458px'},
            height: {base: 'auto', lg: '175px'},
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            padding: {base: '32px 0 40px', lg: 0}
        },
        ordersMaintenancePageTitle: {
            fontSize: {base: '20px', lg: '24px'},
            lineHeight: {base: '24px', lg: '30px'},
            fontWeight: '700',
            textTransform: 'uppercase',
        },
        orderInfoContainer: {
            gap: '0'
        },
        orderPlacedDate: {
            fontSize: {base: 'xs', lg: 'sm'},
            fontWeight: '400',
            color: '#585858',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderTotalWithItemCount: {
            display: 'flex',
            gap: '1px',
            fontSize: {base: 'xs', lg: 'sm'},
            fontWeight: {base: 'medium', lg: 'medium'},
            color: 'black',
            lineHeight: {base: '18px', lg: '20px'}
        },
        remainingCountBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '400',
            fontSize: '16px'
        },
        ordersCardContainer: {
            w: {
                base: 'full',
                lg: '575px',
                xl: '600px',
                '2xl': '620px'
            },
            padding: '16px',
            border: '1px solid #ECE9E9',
            gap: '16px',
            mb: '24px'
        },
        orderStatusText: {
            fontSize: {base: '11px', lg: '12px'},
            textTransform: 'uppercase',
            lineHeight: '18px',
            fontWeight: '500',
            textEdge: 'cap',
            leadingTrim: 'both',
            fontStyle: 'normal',
            mb: '16px'
        },
        manageOrderButton: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: {base: '12px', lg: '14px'},
            lineHeight: {base: '18px', lg: '20px'},
            display: 'block'
        },
        showMoreSection: {
            width: {
                base: 'full',
                lg: '575px',
                xl: '600px',
                '2xl': '620px'
            },
            display: 'flex',
            justifyContent: 'center'
        },
        progressBarContainer: {
            display: 'flex',
            width: {base: 'full', md: '342px'},
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            gap: '0'
        },
        progressBar: {
            width: 'full',
            height: '2px',
            bg: '#C5C5C5',
            borderRadius: '0',
            sx: {
                '& > div': {
                    background: '#000000'
                }
            }
        },
        showOrdersText: {
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            fontSize: '14px',
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: '20px',
            mb: '16px'
        },
        showOrdersTextBold: {
            fontWeight: '700'
        },
        showMoreButton: {
            w: 'full',
            h: '48px',
            fontSize: '14px',
            fontWeight: '700',
            fontStyle: 'normal',
            textTransform: 'uppercase',
            mt: '32px',
            backgroundColor: 'black'
        },
        OrderHistoryHeading: {
            w: {
                base: 'full',
                lg: '575px',
                xl: '600px',
                '2xl': '620px'
            },
            fontSize: {base: '20px', lg: '24px'},
            fontWeight: '700',
            fontStyle: 'normal',
            lineHeight: {base: '24px', lg: '30px'},
            textTransform: 'uppercase'
        },
        storeText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '500',
            fontStyle: 'normal',
            lineHeight: {base: '18px', lg: '20px'}
        },
        onlineText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '500',
            fontStyle: 'normal',
            lineHeight: {base: '18px', lg: '20px'}
        }
    })
}